<template>
  <v-btn
    outline
    round
    color="msr"
    :loading="deactivating"
    class="px-3"
    data-cy="deactivate-campaign-btn"
    @click="$emit('click')"
  >
    <v-icon class="mr-2">
      block
    </v-icon>
    {{ $t('deactivate') }}
  </v-btn>
</template>

<script>
export default {
  name: 'CampaignDeactivationButton',
  props: {
    deactivating: {
      type: Boolean,
      default: false,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/CampaignDeactivationButton.vue